const APP_VERSION = '1784154081848';
export default APP_VERSION;
